export interface Job {
  uuid: string;
  pipeline: string[];
  configuration: any;
  record_count: number;
  tenant_uuid: string;
  tenant_name: string;
  created_by: string;
  created_at: string;
  modified_at: string;
  status: string;
  progress: { [pipeName: string]: PipeProgress | ProgressJobProgress };
  payload: any;
}

export interface PipeProgress {
  count: number;
  total: number;
}

export interface ProgressJobProgress {
  type: string;
  payload: { percent: number };
  status: string;
}

export enum PipeStatus {
  UPLOADING = "uploading",
  BATCHING = "batching",
  PROCESSING = "processing",
  FINISHED = "finished",
  ERROR = "error",
}

export enum PipeNames {
  TEXT_ANALYTICS = "text-analytics",
  PERSISTENCE_SOURCE = "persistence-source",
  PERSISTENCE_SURVEY = "persistence-survey",
  PERSISTENCE_CHAT = "persistence-chat",
  PERSISTENCE_SENTIMENT = "persistence-sentiment",
  SENTIMENT_LEXICON = "sentiment-lexicon",
  TOPIC_ML = "topic-ml",
  INTENT_ML = "intent-ml",
  EMOTION_ML = "emotion-ml",
  TRANSLATE = "translate",
  UPDATE_ML = "update-ml",
  MOCKINGBIRD = "mockingbird",
  RAVEN = "raven",
  FLAMINGO = "flamingo",
  PERSISTENCE_MODEL_RESULTS = "persistence-model-results",
  RETRIEVE_PHRASES_ED = "retrieve-phrases-ed",
  PERSISTENCE_CLUSTER_PHRASES_ED = "persistence-cluster-phrases-ed",
  SETUP_OPERANDS_INDICES = "setup-operands-indices",
  CATEGORIZE_AND_PERSIST = "categorize-and-persist",
  DATA_SOURCE_FULLY_IMPORTED = "data-source-fully-imported",
}

export enum JobProcess {
  UPDATE_CHAT_ML = "update-ml-chat",
  UPDATE_ML = "update-ml",
  SENTIMENT_LEXICON = "sentiment",
  CHAT_ML = "chat-ml",
  SURVEY_ML = "survey-ml",
  SENTIMENT_ML = "sentiment-ml",
  CLUSTER_PHRASES = "cluster_phrases",
  NLP_SPACY = "nlp-spacy",
  CHAT_NLP_SPACY = "chat-nlp-spacy",
}

export enum MockingbirdJobTypes {
  TRAIN = "train",
  TRAIN_WITH_SIMILAR = "find_similar_and_train",
  ANNOTATE_WITH_SIMILAR = "annotate_with_similar",
}

export enum RavenJobTypes {
  CHAT_ML = "chat-ml",
  SURVEY_ML = "survey-ml",
  UPDATE_ML = "update-ml",
  SENTIMENT_ML = "sentiment-ml",
  UPDATE_SENTIMENT_ML = "update-sentiment-ml",
  SENTIMENT_ML_SCHEMA = "sentiment-ml-schema",
}

export const getLatestJob = (jobs: Job[]) => {
  return jobs.sort((a, b) => {
    return b.created_at.localeCompare(a.created_at);
  })[0];
};

export interface PipelineDetails {
  file_path: string;
  file_id: string;
  short_name: string;
  date: string;
  etag: string;
  last_modified: string;
  content_length: string;
  client_request_id: string;
  request_id: string;
  version: string;
  request_server_encrypted: boolean;
  encryption_key_sha256: string;
}
